import React, { useState, useRef, useEffect } from "react";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { confirmAlert } from "react-confirm-alert";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Helper from "../../../../Helper";
import PaymentDetailsQuote from "./paymentdetailsquote";
import AssetesQuote from "./assetsquote";
import Quote from ".";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import Quoteservice from "../../../../services/contract/Quotes/quotesServices";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import { getTrans as t } from "../../../../Localization/translations";
import QuoteView from "./QuoteView";

function QuoteAdd({ id, setShow, contract_number , contract_type}) {
  const form = useRef();
  const checkBtn = useRef();
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();
  
  const [hasProcessingErrors, setHasProcessingErrors] = useState(false);
  const [hideshow, setHideShow] = useState(false)
  const [hide, setHide] = useState(true)
  const [transaction_type, setTransaction_Type] = useState("");
  const [transactiondate, setTransaction_Date] = useState(null);
  const [loading, setLoading] = useState(false)
  const [quote_id, setQuote_id] = useState('')
  let navigate = useNavigate();

  const handleCancel = () => {
    setHide(false)
  }
  const handleRegister = () => {
    form.current.validateAll()
    setHasProcessingErrors(false);

    if (checkBtn.current.context._errors.length === 0) {
    }
    Quoteservice.addquote(
      id,
      transaction_type,
      Helper.DatePicker(transactiondate),
    ).then(
      (response) => {
        if (response.data.success === 1) {
          setQuote_id(response.data.quoteheader_id)
          toast.success(`${response.data.response}`)
          setTimeout(() => {
            setHideShow(true)
          }, 2000)

        }
        else {

          toast.error(`${response.data.error}`)
        }
      }
    ).catch((error) => {
      if (error.response && error.response.status === 400) {
        setHasProcessingErrors(true); 
        toast.error(error.response.data.error || "Data Quality Check Failed.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
      } else {
        toast.error("Failed to create quote");
      }
    })
  }

  const quote_number_method = async () => {
    await axios.get(
      API + `contracts/quote_number_series/`, { headers: authHeader() }
    )
      .then((response) => {
        if (response.data.success === 1) {
        }
        else {
          confirmAlert({
            title: "",
            message: 'Go to settings and update Quotation Setting',
            buttons: [
              {
                label: 'OK',
                onClick: () => navigate("/additionalsettings")
              }
            ]
          })
        }
      })
  }
  useEffect(() => {
    quote_number_method()
  }, [])

  return (
    <>
      <ToastContainer
        autoClose={2000}
      />
      {hide === false ? (
        <Quote id={id} contract_number={contract_number} />
      ) : hideshow === true ? (
        <QuoteView quote_id={quote_id} sethide={setHide}/>
      ) : <>
        <div className="header mb-2 pt-3">
          <h5 className="modal-title text-left" style={{color:'#000000'}}>{t("Create Payoff Quote")}</h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <Form ref={form} onSubmit={handleSubmit(handleRegister)} method="POST"

            >
              {
                <div className="row">
                  <div className="form-group row">
                    <div className="col-md-6">
                      <label className="col-lg-12 col-form-label">
                        {t("Payoff Type")}{" "}
                        <Tooltip content={t("PayoffType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <select
                          value={transaction_type}
                          onChange={(e) => setTransaction_Type(e.target.value)}
                          type="text"
                          className="form-control"
                        >
                          <option value="">Select Payoff Type</option>
                          {contract_type !== 'Rental' ?
                          <option value="Purchase">Purchase</option> :''
                          }
                          <option value="Return">Return</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-lg-12 col-form-label">
                        {t("Termination Date")}{" "}
                        <Tooltip content={t("TerminationDate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <input type="text" value={transactiondate
                          ? Helper.DateNormal(transactiondate)
                          : ""} disabled className="form-control">

                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <label className="col-lg-12 col-form-label">
                {t("Please Choose Termination Date")}{" "}
              </label>
              <div className="">
                <PaymentDetailsQuote id={id} transactiondate={setTransaction_Date} />
              </div>

              <label className="col-lg-12 col-form-label mt-4">
              </label>
              <div className="mt-3 mb-3">
                <AssetesQuote id={id} />
              </div>
              <div className="text-left py-3 d-flex align-items-center">
                <input type="hidden" id="assetId" />
                <button type="button" className="asset-cancel btn btn-secondary btn-md" onClick={handleCancel}>{t("Cancel")}</button>&nbsp;&nbsp;
                <button type="submit" className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md">
                  {
                    loading === false ? (
                      t('Save')
                    ) : (
                      <ButtonLoading />
                    )
                  }
                </button>

                {hasProcessingErrors && (
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#dc3545",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: "500",
                      marginLeft: "15px"
                    }}
                    onClick={() => navigate("/processing-failure-log", { state: { contract_id: id } })}
                  >
                    {t("Review Errors")}
                  </span>
                )}
              </div>

              <CheckButton style={{ display: "none" }} ref={checkBtn} />

            </Form>
          </div>
        </div>

      </>}


    </>
  );
}

export default QuoteAdd;
